'use client'
import CountUp from "react-countup";
import {useState} from "react";
import classes from './NumberCounter.module.scss'

const NumberCounter = ({label = '', end, duration, addPlus}) => {
    const [animationFinished, setAnimationFinished] = useState(false);
    const handleAnimationEnd = () => {
        setAnimationFinished(true);
    };
    return (
        <div className={classes.wrapper}>
            <CountUp
                enableScrollSpy={true}
                scrollSpyOnce={true}
                end={end}
                duration={duration}
                onEnd={handleAnimationEnd}
            />
            {animationFinished && addPlus && <span>+</span>}
            {label && <p className={classes.label}>{label}</p>}
        </div>
    );
};

export default NumberCounter;